import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { PopUpDialogInformalService } from "../../services/confirms/popUpDialogInformal.service";
import { PopUpInformalType } from "../../components/ui-components/pop-ups/pop-up-informal/pop-up-informal.model";
import { environment } from "src/environments/environment";
import { LoginService } from "@dert-services";

@Component({
  selector: "forbidden",
  templateUrl: "./forbidden.component.html",
  styleUrls: ["./forbidden.component.scss"],
  imports: [
    TranslateModule,
    CommonModule,
  ],
  standalone: true,
})
export class ForbiddenComponent {
  private translate = inject(TranslateService);
  private popUpDialogInformalService = inject(PopUpDialogInformalService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private loginService = inject(LoginService);

  async ngOnInit() {
    const isMultipleTabs = this.route.snapshot.queryParamMap.get("reason") === "multiple-tabs";

    if (!isMultipleTabs && !this.loginService.loggedIn) {
      await this.router.navigate(["/dashboard"], { replaceUrl: true });
      return;
    }

    const titleKey = isMultipleTabs ? "webPos.MultipleTabsTitle" : "webPos.ForbiddenTitle";
    const messageKey = isMultipleTabs ? "webPos.MultipleTabsMessage" : "webPos.ForbiddenMessage";

    await this.popUpDialogInformalService.confirm({
      title: this.translate.instant(titleKey),
      message: this.translate.instant(messageKey),
      type: PopUpInformalType.Error,
    });

    this.loginService.logout();
    window.location.href = environment.fallbackUrl;
  }
}
